// extracted by mini-css-extract-plugin
export var menuIcon = "_nz-0";
export var menuIconInline = "_nz-1";